import { BookingsDto } from '../../types';

export const IBookingApiId = Symbol.for('IBookingApi');

export interface IBookingApi {
    /**
     * Get user bookings.
     */
    getBookings(): Promise<BookingsDto | undefined>;

    /**
     * Cancel booking.
     * @param bookingId
     */
    cancelBooking(bookingId: string): Promise<BookingsDto | undefined>;
}
